import 'styles/components/dropdown.scss'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: props.show
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.show !== nextProps.show) {
      return {
        ...prevState,
        show: nextProps.show
      }
    }

    return prevState
  }

  render() {
    const { className, children } = this.props
    const { show } = this.state
    const dropdownClassName = classnames('dropdown', className, {
      'is-active': show
    })

    return <div className={dropdownClassName}>{children}</div>
  }
}

Dropdown.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  show: PropTypes.bool
}

Dropdown.defaultProps = {
  className: null,
  children: null,
  show: false
}
